//375
import pizzaOne375 from '../assets/images/menu-slider/margherita.webp'
import pizzaTwo375 from '../assets/images/menu-slider/prosciutto.webp'
import pizzaThree375 from '../assets/images/menu-slider/salami.webp'
import SalmonPoke375 from '../assets/images/menu-slider/cocacola.webp'
import VeggiePoke375 from '../assets/images/menu-slider/fanta.webp'
import MiniSalmon375 from '../assets/images/menu-slider/water.webp'
import ChickenAlfredo375 from '../assets/images/menu-slider/topping.webp'
import AllaGricia375 from '../assets/images/menu-slider/topping.webp'
import SheetPan375 from '../assets/images/menu-slider/topping.webp'

const menuSliderCategories = [
    {
      name: 'pizza',
      id: 'pizza',
    },
    {
      name: 'getränk',
      id: 'getränk',
    },
    {
      name: 'extra',
      id: 'extra',
    },
  ]
  const menuSliderProducts = [
    {
      id: 'margherita-pizza',
      name: 'Margherita Pizza',
      describtion:
        'Ein zeitloser Klassiker mit knusprig-dünnem Boden, reichhaltiger Tomatensauce, frischem Mozzarella und duftendem Basilikum – der authentische Geschmack Italiens in jedem Bissen.',
      price: (9).toFixed(2),
      img: pizzaOne375,
      category: 'pizza',
    },
    {
      id: 'prosciutto-pizza',
      name: 'Prosciutto und Rucola',
      describtion:
        'Eine perfekte Harmonie aus zartem Prosciutto und pfeffrigem Rucola auf einem goldgebackenen Boden – verfeinert mit einem Schuss Olivenöl für ein besonders edles Geschmackserlebnis.',
      price: (13).toFixed(2),
      img: pizzaTwo375,
      category: 'pizza',
    },
    {
      id: 'salami-pizza',
      name: 'Salami Pizza',
      describtion:
        'Ein kräftiger, herzhafter Genuss – belegt mit hochwertiger Salami, würziger Tomatensauce und einer perfekten Mischung aus geschmolzenem Provolone und Mozzarella auf knusprigem Boden.',
      price: (12).toFixed(2),
      img: pizzaThree375,
      category: 'pizza',
    },
    {
      id: 'coca-cola',
      img: SalmonPoke375,
      name: 'Coca Cola 0,33l',
      describtion: 'Coca Cola 0,33l',
      price: (2.40).toFixed(2),
      category: 'getränk',
    },
    {
      id: 'fanta',
      img: VeggiePoke375,
      name: 'Fanta 0,33l',
      describtion: 'Fanta 0,33l',
      price: (2.40).toFixed(2),
      category: 'getränk',
    },
    {
      id: 'water',
      img: MiniSalmon375,
      name: 'Mineralwasser 0,5l',
      describtion: 'Mineralwasser 0,5l',
      price: (2.80).toFixed(2),
      category: 'getränk',
    },
    {
      id: 'topping1',
      img: ChickenAlfredo375,
      name: 'Extra Rucola + Schinken',
      describtion: 'Extra Rucola + Schinken',
      price: (4).toFixed(2),
      category: 'extra',
    },
    {
      id: 'topping2',
      img: AllaGricia375,
      name: 'Extra Schinken',
      describtion: 'Extra Schinken',
      price: (2.2).toFixed(2),
      category: 'extra',
    },
    {
      id: 'topping3',
      img: SheetPan375,
      name: 'Extra Schinken + Salami',
      describtion: 'Extra Schinken + Salami',
      price: (4).toFixed(2),
      category: 'extra',
    },
  ]

export { menuSliderProducts, menuSliderCategories };